import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-thumbUp",
  "use": "svgIcon-thumbUp-usage",
  "viewBox": "0 0 438.6 438.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 438.6 438.6\" id=\"svgIcon-thumbUp\"><path d=\"m331 155c-3.2-8.7 86-89 34-153-12.2-15-53.6 72-112 112-32.5 21.9-101 66-108 94 0 0-13.6 46.9-13.6 88 0 40.8 13.6 79 13.6 79 13.6 29.8 120 63.8 211 63.8 33 0 82-209 82-242 0-33-103-32.7-106-41m-309 18.4h102c0 0-20.4 54-20.4 122 0 82 20.4 116 20.4 116h-102c0 0-20.4-54-20.4-109 0-88 20.4-129 20.4-129\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol